const KEY = "lm_src";

export function captureSource() {
  const p = new URLSearchParams(window.location.search);
  if (localStorage.getItem(KEY) && !p.get("utm_source") && !p.get("gclid") && !p.get("fbclid")) return;
  const click = p.get("gclid") ? "gclid" : p.get("fbclid") ? "fbclid" : "";
  localStorage.setItem(KEY, JSON.stringify({ ref: (document.referrer || "").slice(0, 400), utm: (p.get("utm_source") || "").slice(0, 80), campaign: (p.get("utm_campaign") || "").slice(0, 60), click }));
}

export function getSource() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
}
